import { createApp } from 'vue';
import App from './App.vue';
import { iniciarSocket } from '@/plugins/socket';
import { createPinia } from 'pinia';
import router from './router';

import * as BootstrapVueNext from 'bootstrap-vue-next';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import "./assets/css/estilo.css";
import '@fortawesome/fontawesome-free/css/all.css';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import { register } from 'register-service-worker'

import { install } from "vue3-recaptcha-v2";

const pinia = createPinia();
const socket = iniciarSocket('');

const app = createApp(App);

Object.entries(BootstrapVueNext).forEach(([name, component]) => {
	if (name.startsWith('B')) {
		app.component(name, component);
	} else if (name.endsWith('Directive')) {
		app.directive(name.replace('Directive', '').toLowerCase(), component);
	}
});

if (process.env.NODE_ENV === 'production') {
	register(`${process.env.BASE_URL}service-worker.js`, {
		ready() {
			console.log(
				'App is being served from cache by a service worker.\n' +
				'For more details, visit https://goo.gl/AFskqB'
			)
		},
		registered() {
			console.log('Service worker has been registered.')
		},
		cached() {
			console.log('Content has been cached for offline use.')
		},
		updatefound() {
			console.log('New content is downloading.')
		},
		updated() {
			console.log('New content is available; please refresh.')
		},
		offline() {
			console.log('No internet connection found. App is running in offline mode.')
		},
		error(error) {
			console.error('Error during service worker registration:', error)
		}
	})
}

app.use(VueSweetalert2);
app.use(pinia);
app.use(router);
app.use(install, {
	sitekey: process.env.VUE_APP_SITE_KEY,
	loaderOptions: {
		autoLoad: true
	}
});
app.config.globalProperties.$socket = socket;
app.mount('#app');

window.app = app;